import { useCallback } from 'react';
import { useTranslation } from '../../lib/i18n.js';

/** A folder's name as shown: the "Public external" system folder is named in the reader's language (ADR-0056). */
export function useFolderLabel() {
  const { t } = useTranslation();
  return useCallback((folder: { name: string; systemKind?: string | null }) => (folder.systemKind === 'PUBLIC_EXTERNAL' ? t('documents.public.folderName') : folder.name), [t]);
}
